const moveOrderToSaveForLater = (state, transactionIdToMove) => {
	const index = state.items.findIndex((id) => String(id) === String(transactionIdToMove));
	if (index === -1) return;

	const [movedId] = state.items.splice(index, 1);
	if (!state.savedForLaterItems.some((id) => String(id) === String(movedId))) {
		state.savedForLaterItems = [...state.savedForLaterItems, movedId].sort();
	}
};

const moveOrderToCheckout = (state, transactionIdToMove) => {
	const index = state.savedForLaterItems.findIndex((id) => String(id) === String(transactionIdToMove));
	if (index === -1) return;

	const [movedId] = state.savedForLaterItems.splice(index, 1);
	if (!state.items.some((id) => String(id) === String(movedId))) {
		state.items = [...state.items, movedId].sort();
	}
};

export const updateCheckoutItemFulfilledAction = (state, { meta }) => {
	state.orderSummary.isLoading = false;
	const { transactionId, changes } = meta?.arg || {};
	if (changes?.saved_for_later === true) moveOrderToSaveForLater(state, transactionId);
	if (changes?.saved_for_later === false) moveOrderToCheckout(state, transactionId);
};
